import type { TRuleWithTheme } from '@/styles/theme';

export const container: TRuleWithTheme = () => ({
    display: 'contents',
});

export const text: TRuleWithTheme = () => ({
    fontSize: '1rem',
    fontWeight: 600,
    lineHeight: '1.5rem',

    '&.ant-btn-text.ant-btn-lg': {
        paddingInline: 0,
    },

    min768: {
        '&.ant-btn-text.ant-btn-lg': {
            paddingInline: '0.375rem',
        },
    },
});
